import { render, staticRenderFns } from "./modal-slots-not-available-alert.vue?vue&type=template&id=01f433d2&"
import script from "./modal-slots-not-available-alert.vue?vue&type=script&lang=js&"
export * from "./modal-slots-not-available-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports